// new okendo custom code
// Adjust the main widget on product pages to thicken the line for the slightly "True to Size" indicator
window.addEventListener('load', function() {
    setTimeout(() => {
      let mainWidgetSizeBar = document.querySelector("#product-reviews .oke-w-header-content .oke-barBlocks--centered");
      if(mainWidgetSizeBar){
  
          let precentageText = document.querySelector("#product-reviews .oke-w-header-content .oke-attrBar-title .oke-a11yText").innerText;
          if(precentageText.includes("0.0")){
            
              mainWidgetSizeBar.querySelector(".oke-barBlocks-bg-shading").style.setProperty("min-width", "30px", "important");
              mainWidgetSizeBar.querySelector(".oke-barBlocks-bg-shading").style.setProperty("transform", "translateX(-13px)", "important");
              mainWidgetSizeBar.querySelector(".oke-barBlocks-bg-centerLine").style.setProperty("background", "transparent", "important");
          }
      }
    const oke_select = document.querySelector("#oke-sortSelect--reviews");
    if (oke_select){
        const optionToHide = oke_select.querySelector('option[value*="has_media"]');
        optionToHide.style.display = 'none'; 
        optionToHide.hidden = true; 
    }

    }, 500);
})
